import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { WebPage } from '../models/WebPage';
import { MatTableDataSource } from '@angular/material/table';
import { ApiProvider } from '../providers/api.provider';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WebpagesService {

  private currentWebPageSubject: BehaviorSubject<WebPage[]>;
  public currentWebPage: Observable<WebPage[]>;
  public dataSource: MatTableDataSource<WebPage>;
  constructor(private apiProvider: ApiProvider) { 
    this.currentWebPageSubject = new BehaviorSubject<WebPage[]>(null);
  }
  
  public get currentWebPageValue(): WebPage[] {
    return this.currentWebPageSubject.value;
  }
  
  public currentWebPageValueByParentID(webPageParentID:number): WebPage[] {
    return this.currentWebPageValue.filter(x => x.WebPageParentID === webPageParentID);
  }

  public WebPage(webPageID:number): WebPage {
    return this.currentWebPageValue.find(x => x.WebPageID === webPageID);
  }

  async initialiseWebPages(ParentID:number, languageID: number) {
    this.apiProvider.WebPages(ParentID, languageID).subscribe((webPages: WebPage[]) => {
      this.currentWebPageSubject = new BehaviorSubject<WebPage[]>(webPages);
      this.currentWebPage = this.currentWebPageSubject.asObservable();
      this.dataSource = new MatTableDataSource<WebPage>(webPages);
    }, (err: HttpErrorResponse) => {
      this.currentWebPageSubject.next(null);
    });
  }
}
